import React, { useEffect, useState } from "react";
import TopNav from "../layouts/TopNav";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "../Styles/genratedslip.css";
import { BsPencil } from "react-icons/bs";
import { toast } from "react-toastify";
import logo from "../asset/Image/logo-.png";
import Swal from "sweetalert2";
import { CircularProgress } from "@mui/material";
import ReLoginModal from "../components/ReLoginModal";
import api from "../util/axios";

type Requisition = {
  _id: string;
  approvalNumber: string;
  availableToBook: number;
  customer: {
    _id: string;
    businessName: string;
  };
  itemId: string;
  itemName: string;
  quantity: number;
  quantityToLoad: number;
  totalCost: number;
  unitPrice: number;
};

type Invoice = {
  loader: string;
  supplyLocation: string;
  destination: string;
  ullager: string;
  started: string;
  completed: string;
  meterBefore: string;
  meterAfter: string;
  Cfirst: string;
  Csecond: string;
  Cthird: string;
  Cfourth: string;
  Cfifth: string;
  Csixth: string;
  Cseventh: string;
  Ufirst: string;
  Usecond: string;
  Uthird: string;
  Ufourth: string;
  Ufifth: string;
  Usixth: string;
  Useventh: string;
  truckNumber: string;
  driver: string;
  driverNum: string;
  capacity: string;
  quantityLoaded: string;
};

type LoadingSlip = {
  _id: string;
  loadingNumber: string;
  truckNumber: string;
  supplyLocation: string;
  requisitions: Requisition[];
  selectMvt?: string;
  transporter?: string;
  selectedDriverDetails?: { driver: string };
  staff: { name: string; role: string };
};

const applyPrintStyles = (
  slipElement: HTMLElement,
  printButtons: HTMLElement | null,
  editButton: HTMLElement | null
): {
  table: HTMLElement | null;
  tds: NodeListOf<HTMLElement>;
  inputs: NodeListOf<HTMLInputElement>;
  destinationInput: HTMLInputElement | null;
  qtyToBeLoadedCell: HTMLElement | null;
  qtyLoadedCell: HTMLElement | null;
  meterBeforeCell: HTMLElement | null;
  redStars: NodeListOf<HTMLElement>;
  logo: HTMLImageElement | null;
  waterMark: HTMLElement | null;
  waterMarkSpan: HTMLElement | null;
  generatedByText: HTMLElement | null;
} => {
  if (printButtons) printButtons.style.display = "none";
  if (editButton) editButton.style.display = "none";

  slipElement.style.width = "203.2mm";
  slipElement.style.height = "171.45mm";
  slipElement.style.margin = "2mm";
  slipElement.style.padding = "2mm";
  slipElement.style.fontSize = "10px";
  slipElement.style.lineHeight = "1.2";
  slipElement.style.background = "#fff";
  slipElement.style.color = "#000";
  slipElement.style.fontFamily = "'Montserrat', sans-serif";
  slipElement.style.float = "none";
  slipElement.style.transform = "scale(1)";
  slipElement.style.overflow = "visible";
  slipElement.style.boxSizing = "border-box";
  slipElement.style.position = "relative";

  const table = slipElement.querySelector("table") as HTMLElement | null;
  if (table) {
    table.style.width = "100%";
    table.style.height = "auto";
    table.style.border = "0.1px solid #000";
    table.style.marginBottom = "0";
    table.style.borderCollapse = "collapse";
    table.style.tableLayout = "fixed";
  }

  const tds = slipElement.querySelectorAll("table td") as NodeListOf<HTMLElement>;
  tds.forEach((td) => {
    td.style.border = "0.1px solid #000";
    td.style.padding = "1mm";
    td.style.fontSize = "10px";
    td.style.whiteSpace = "normal";
    td.style.overflow = "hidden";
    td.style.wordWrap = "break-word";
    td.style.boxSizing = "border-box";
  });

  const qtyToBeLoadedCell = slipElement.querySelector("td:nth-child(5):nth-last-child(7)") as HTMLElement | null;
  const qtyLoadedCell = slipElement.querySelector("td:nth-child(5):nth-last-child(6)") as HTMLElement | null;
  const meterBeforeCell = slipElement.querySelector("td:nth-child(5):nth-last-child(5)") as HTMLElement | null;

  if (qtyToBeLoadedCell) qtyToBeLoadedCell.style.width = "12%";
  if (qtyLoadedCell) qtyLoadedCell.style.width = "12%";
  if (meterBeforeCell) meterBeforeCell.style.width = "12%";

  const inputs = slipElement.querySelectorAll("input") as NodeListOf<HTMLInputElement>;
  inputs.forEach((input) => {
    input.style.display = "none";
    input.style.width = "100%";
    input.style.fontSize = "10px";
  });

  const destinationInput = slipElement.querySelector(".destination input") as HTMLInputElement | null;
  if (destinationInput) destinationInput.style.display = "none";

  const redStars = slipElement.querySelectorAll(".require_star") as NodeListOf<HTMLElement>;
  redStars.forEach((star) => {
    star.style.display = "none";
  });

  const logo = slipElement.querySelector("img.w-22.h-16") as HTMLImageElement | null;
  if (logo) {
    logo.style.width = "40mm";
    logo.style.height = "20mm";
  }

  const waterMark = slipElement.querySelector(".waterMark") as HTMLElement | null;
  let waterMarkSpan: HTMLElement | null = null;
  if (waterMark) {
    waterMark.style.position = "absolute";
    waterMark.style.top = "120mm";
    waterMark.style.left = "-15mm";
    waterMark.style.transform = "rotate(-45deg)";
    waterMark.style.width = "auto";
    waterMark.style.textAlign = "left";
    waterMark.style.zIndex = "1";
    waterMark.style.pointerEvents = "none";
    waterMark.style.color = "#000";
    waterMarkSpan = waterMark.querySelector("span") as HTMLElement | null;
    if (waterMarkSpan) {
      waterMarkSpan.style.fontSize = "45px";
      waterMarkSpan.style.opacity = "0.3";
      waterMarkSpan.style.fontWeight = "bold";
      waterMarkSpan.style.color = "#000";
    }
  }

  const generatedByText = slipElement.querySelector("p.text-blue-800") as HTMLElement | null;
  if (generatedByText) {
    generatedByText.style.fontSize = "6px";
  }

  return {
    table,
    tds,
    inputs,
    destinationInput,
    qtyToBeLoadedCell,
    qtyLoadedCell,
    meterBeforeCell,
    redStars,
    logo,
    waterMark,
    waterMarkSpan,
    generatedByText,
  };
};

const resetStyles = (
  slipElement: HTMLElement,
  printButtons: HTMLElement | null,
  editButton: HTMLElement | null,
  table: HTMLElement | null,
  tds: NodeListOf<HTMLElement>,
  inputs: NodeListOf<HTMLInputElement>,
  destinationInput: HTMLInputElement | null,
  qtyToBeLoadedCell: HTMLElement | null,
  qtyLoadedCell: HTMLElement | null,
  meterBeforeCell: HTMLElement | null,
  redStars: NodeListOf<HTMLElement>,
  logo: HTMLImageElement | null,
  waterMark: HTMLElement | null,
  waterMarkSpan: HTMLElement | null,
  generatedByText: HTMLElement | null
): void => {
  if (printButtons) printButtons.style.display = "block";
  if (editButton) editButton.style.display = "block";
  slipElement.style.cssText = "";
  if (table) table.style.cssText = "";
  tds.forEach((td) => (td.style.cssText = ""));
  inputs.forEach((input) => (input.style.cssText = ""));
  if (destinationInput) destinationInput.style.cssText = "";
  if (qtyToBeLoadedCell) qtyToBeLoadedCell.style.cssText = "";
  if (qtyLoadedCell) qtyLoadedCell.style.cssText = "";
  if (meterBeforeCell) meterBeforeCell.style.cssText = "";
  redStars.forEach((star) => (star.style.cssText = ""));
  if (logo) logo.style.cssText = "";
  if (waterMark) {
    waterMark.style.cssText = "";
    if (waterMarkSpan) waterMarkSpan.style.cssText = "";
  }
  if (generatedByText) generatedByText.style.cssText = "";
};

const MergedGeneratedSlipNotInvoiced = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [reLogin, setReLogin] = useState(false);
  const mergedSlips: { selectedData: LoadingSlip[] } = location.state;
  const slips = mergedSlips.selectedData;

  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState<{ [key: string]: boolean }>({});
  const [invoiceComplete, setInvoiceComplete] = useState<{
    [key: string]: boolean;
  }>({});
  const [invoices, setInvoices] = useState<{ [key: string]: Invoice }>(
    slips.reduce((acc, slip) => ({
      ...acc,
      [slip._id]: {
        loader: "",
        supplyLocation: "First Royal Oil Nigeria Limited",
        destination: "",
        ullager: "",
        started: "",
        completed: "",
        meterBefore: "",
        meterAfter: "",
        Cfirst: "",
        Csecond: "",
        Cthird: "",
        Cfourth: "",
        Cfifth: "",
        Csixth: "",
        Cseventh: "",
        Ufirst: "",
        Usecond: "",
        Uthird: "",
        Ufourth: "",
        Ufifth: "",
        Usixth: "",
        Useventh: "",
        truckNumber: slip.truckNumber || "",
        driver: slip.selectedDriverDetails?.driver || "",
        driverNum: "",
        capacity: "",
        quantityLoaded: "",
      },
    }), {})
  );
  const [currentDateTime, setCurrentDateTime] = useState("");

  const updateSlip = (slip: LoadingSlip) => {
    const originalTruckNumber = slip.truckNumber;
    const updatedTruckNumber = invoices[slip._id].truckNumber;
    const slipId = slip._id;
    if (originalTruckNumber !== updatedTruckNumber) {
      api
        .patch(
          `/loading-slip/reprint/${slipId}`,
          { truckNumber: updatedTruckNumber },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${window.localStorage.getItem("token")}`,
            },
          }
        )
        .then((res) => {
          toast.success("Truck number updated successfully!");
        })
        .catch((err) => {
          if (
            err.response?.data?.message === "jwt expired" ||
            err.response?.data?.message === "jwt malformed"
          ) {
             
            setReLogin(true);
          } else {
            setReLogin(false);
          }
          toast.error(err.response.data.message);
        });
    }
  };

  const printAllSlips = () => {
    const slipElements = document.querySelectorAll(
      ".generatedSlip"
    ) as NodeListOf<HTMLElement>;
    const printButtons = document.querySelector(".print") as HTMLElement | null;
    const editButtons = document.querySelectorAll(
      ".editText"
    ) as NodeListOf<HTMLElement>;

    if (slipElements.length === 0) {
      console.error("No slip elements (.generatedSlip) found in the DOM.");
      return;
    }

    // Create a temporary container for printing
    const printContainer = document.createElement("div");
    printContainer.className = "print-container";
    printContainer.style.position = "absolute";
    printContainer.style.top = "0";
    printContainer.style.left = "0";
    printContainer.style.zIndex = "1000";
    printContainer.style.width = "210mm"; // A4 width
    printContainer.style.display = "flex";
    printContainer.style.flexDirection = "column";
    printContainer.style.alignItems = "center";

    const styledSlips: {
      element: HTMLElement;
      table: HTMLElement | null;
      tds: NodeListOf<HTMLElement>;
      inputs: NodeListOf<HTMLInputElement>;
      destinationInput: HTMLInputElement | null;
      qtyToBeLoadedCell: HTMLElement | null;
      qtyLoadedCell: HTMLElement | null;
      meterBeforeCell: HTMLElement | null;
      redStars: NodeListOf<HTMLElement>;
      logo: HTMLImageElement | null;
      waterMark: HTMLElement | null;
      waterMarkSpan: HTMLElement | null;
      generatedByText: HTMLElement | null;
    }[] = [];

    // Group slips into pairs for each page
    for (let i = 0; i < slipElements.length; i += 2) {
      const pageDiv = document.createElement("div");
      pageDiv.className = "print-page";
      pageDiv.style.width = "210mm";
      pageDiv.style.height = "297mm"; // A4 height
      pageDiv.style.display = "flex";
      pageDiv.style.flexDirection = "column";
      pageDiv.style.alignItems = "center";
      pageDiv.style.pageBreakAfter = "always";

      // First slip in the pair
      const slip1 = slipElements[i];
      const editButton1 = editButtons[i];
      const styled1 = applyPrintStyles(slip1, null, editButton1);
      styledSlips.push({
        element: slip1,
        table: styled1.table,
        tds: styled1.tds,
        inputs: styled1.inputs,
        destinationInput: styled1.destinationInput,
        qtyToBeLoadedCell: styled1.qtyToBeLoadedCell,
        qtyLoadedCell: styled1.qtyLoadedCell,
        meterBeforeCell: styled1.meterBeforeCell,
        redStars: styled1.redStars,
        logo: styled1.logo,
        waterMark: styled1.waterMark,
        waterMarkSpan: styled1.waterMarkSpan,
        generatedByText: styled1.generatedByText,
      });

      const clonedSlip1 = slip1.cloneNode(true) as HTMLElement;
      clonedSlip1.className = `generatedSlip cloned-slip slip-${i}`;
      clonedSlip1.style.marginBottom = "2mm";

      // Create and append watermark for first slip
      const waterMark1 = document.createElement("div");
      waterMark1.className = "waterMark";
      waterMark1.style.position = "absolute";
      waterMark1.style.top = "120mm";
      waterMark1.style.left = "-15mm";
      waterMark1.style.transform = "rotate(-45deg)";
      waterMark1.style.width = "auto";
      waterMark1.style.textAlign = "left";
      waterMark1.style.zIndex = "1";
      waterMark1.style.pointerEvents = "none";
      waterMark1.style.color = "#000";
      const waterMarkSpan1 = document.createElement("span");
      waterMarkSpan1.style.fontSize = "45px";
      waterMarkSpan1.style.opacity = "0.3";
      waterMarkSpan1.style.fontWeight = "bold";
      waterMarkSpan1.style.color = "#000";
      waterMarkSpan1.textContent = slips[i].requisitions[0]?.itemName || "N/A";
      waterMark1.appendChild(waterMarkSpan1);
      clonedSlip1.appendChild(waterMark1);

      pageDiv.appendChild(clonedSlip1);
      updateSlip(slips[i]);

      // Second slip in the pair, if it exists
      if (i + 1 < slipElements.length) {
        const slip2 = slipElements[i + 1];
        const editButton2 = editButtons[i + 1];
        const styled2 = applyPrintStyles(slip2, null, editButton2);
        styledSlips.push({
          element: slip2,
          table: styled2.table,
          tds: styled2.tds,
          inputs: styled2.inputs,
          destinationInput: styled2.destinationInput,
          qtyToBeLoadedCell: styled2.qtyToBeLoadedCell,
          qtyLoadedCell: styled2.qtyLoadedCell,
          meterBeforeCell: styled2.meterBeforeCell,
          redStars: styled2.redStars,
          logo: styled2.logo,
          waterMark: styled2.waterMark,
          waterMarkSpan: styled2.waterMarkSpan,
          generatedByText: styled2.generatedByText,
        });

        const clonedSlip2 = slip2.cloneNode(true) as HTMLElement;
        clonedSlip2.className = `generatedSlip cloned-slip slip-${i + 1}`;

        // Create and append watermark for second slip
        const waterMark2 = document.createElement("div");
        waterMark2.className = "waterMark";
        waterMark2.style.position = "absolute";
        waterMark2.style.top = "120mm";
        waterMark2.style.left = "-15mm";
        waterMark2.style.transform = "rotate(-45deg)";
        waterMark2.style.width = "auto";
        waterMark2.style.textAlign = "left";
        waterMark2.style.zIndex = "1";
        waterMark2.style.pointerEvents = "none";
        waterMark2.style.color = "#000";
        const waterMarkSpan2 = document.createElement("span");
        waterMarkSpan2.style.fontSize = "45px";
        waterMarkSpan2.style.opacity = "0.3";
        waterMarkSpan2.style.fontWeight = "bold";
        waterMarkSpan2.style.color = "#000";
        waterMarkSpan2.textContent = slips[i + 1].requisitions[0]?.itemName || "N/A";
        waterMark2.appendChild(waterMarkSpan2);
        clonedSlip2.appendChild(waterMark2);

        pageDiv.appendChild(clonedSlip2);
        updateSlip(slips[i + 1]);
      }

      printContainer.appendChild(pageDiv);
    }

    // Hide original slips
    slipElements.forEach((slip) => {
      slip.style.visibility = "hidden";
    });
    if (printButtons) printButtons.style.display = "none";

    // Append print container to body
    document.body.appendChild(printContainer);

    // Trigger print dialog
    window.print();

    // Clean up
    setTimeout(() => {
      slipElements.forEach((slipElement, index) => {
        slipElement.style.visibility = "visible";
        resetStyles(
          slipElement,
          null,
          editButtons[index],
          styledSlips[index].table,
          styledSlips[index].tds,
          styledSlips[index].inputs,
          styledSlips[index].destinationInput,
          styledSlips[index].qtyToBeLoadedCell,
          styledSlips[index].qtyLoadedCell,
          styledSlips[index].meterBeforeCell,
          styledSlips[index].redStars,
          styledSlips[index].logo,
          styledSlips[index].waterMark,
          styledSlips[index].waterMarkSpan,
          styledSlips[index].generatedByText
        );
      });
      if (printButtons) printButtons.style.display = "block";
      document.body.removeChild(printContainer);
      navigate("/dashboard/notinvoiced");
    }, 100);
  };

  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const hours = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;
    setCurrentDateTime(formattedDate);
  }, []);

  const token = window.localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleChange = (
    slipId: string,
    { target: { name, value } }: React.ChangeEvent<HTMLInputElement>
  ) => {
    setInvoices((prevInvoices) => {
      let updatedInv = { ...prevInvoices[slipId], [name]: value };

      if (name === "meterBefore" || name === "quantityLoaded") {
        const meterBefore = parseFloat(updatedInv.meterBefore || "0");
        const totalQuantityLoaded = parseFloat(updatedInv.quantityLoaded || "0");
        updatedInv.meterAfter = (meterBefore + totalQuantityLoaded).toFixed(2);
      }

      return { ...prevInvoices, [slipId]: updatedInv };
    });
  };

  const handleSubmit = async (e: React.FormEvent, slip: LoadingSlip) => {
    e.preventDefault();

    const totalQuantityToLoad = slip.requisitions.reduce(
      (acc: number, req: Requisition) => acc + req.quantityToLoad,
      0
    );
    const inv = invoices[slip._id];

    const totalCompartmentVolume = [
      inv.Cfirst,
      inv.Csecond,
      inv.Cthird,
      inv.Cfourth,
      inv.Cfifth,
      inv.Csixth,
      inv.Cseventh,
    ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0);

    if (totalCompartmentVolume !== totalQuantityToLoad) {
      Swal.fire({
        title: "Error!",
        text: `Total value in compartments (${totalCompartmentVolume}) should be equal to Quantity To Be Loaded (${totalQuantityToLoad}).`,
        icon: "error",
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
      return;
    }

    const totalQuantityLoaded = parseFloat(inv.quantityLoaded || "0");
    if (totalQuantityLoaded !== totalQuantityToLoad) {
      Swal.fire({
        title: "Error!",
        text: `Total Quantity Loaded (${totalQuantityLoaded}) must be equal to Quantity To Load (${totalQuantityToLoad}).`,
        icon: "error",
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
      return;
    }

    const meterBefore = parseFloat(inv.meterBefore);
    const meterAfter = parseFloat(inv.meterAfter);
    if (meterAfter - meterBefore !== totalQuantityLoaded) {
      Swal.fire({
        title: "Error!",
        text: `Difference between Meter After (${meterAfter}) and Meter Before (${meterBefore}) should be equal to Total Quantity Loaded (${totalQuantityLoaded}).`,
        icon: "error",
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
      return;
    }

    const distributedQuantities = slip.requisitions.map((req: Requisition) => {
      const proportion = req.quantityToLoad / totalQuantityToLoad;
      return {
        ...req,
        quantityLoaded: (totalQuantityLoaded * proportion).toFixed(2),
      };
    });

    setLoading(true);
    try {
      const res = await api.patch(
        `/loading-slip/${slip._id}`,
        {
          supplyLocation: inv.supplyLocation,
          destination: inv.destination,
          loader: inv.loader,
          ullager: inv.ullager,
          loadingTime: {
            started: inv.started,
            completed: inv.completed,
          },
          meterBefore: inv.meterBefore,
          meterAfter: inv.meterAfter,
          compartmentNo: {
            first: inv.Cfirst,
            second: inv.Csecond,
            third: inv.Cthird,
            fourth: inv.Cfourth,
            fifth: inv.Cfifth,
            sixth: inv.Csixth,
            seventh: inv.Cseventh,
          },
          ullage: {
            first: inv.Ufirst,
            second: inv.Usecond,
            third: inv.Uthird,
            fourth: inv.Ufourth,
            fifth: inv.Ufifth,
            sixth: inv.Usixth,
            seventh: inv.Useventh,
          },
          requisitions: distributedQuantities.map(
            (req: Requisition & { quantityLoaded: string }) => ({
              approvalNumber: req.approvalNumber,
              availableToBook: req.availableToBook,
              customer: req.customer,
              businessName: req.customer._id,
              itemId: req.itemId,
              itemName: req.itemName,
              quantity: req.quantity,
              quantityLoaded: parseFloat(req.quantityLoaded),
              quantityToLoad: req.quantityToLoad,
              totalCost: req.totalCost,
              unitPrice: req.unitPrice,
              _id: req._id,
            })
          ),
          transporter: slip.selectMvt,
          truckNumber: inv.truckNumber,
          driver:
            slip.transporter === "SELF COLLECTION"
              ? inv.driver
              : slip.selectedDriverDetails?.driver,
          capacity: inv.capacity,
          invoiced: invoiceComplete[slip._id],
        },
        { headers }
      );

      Swal.fire({
        title: "Success!",
        text: `${res.data.message}`,
        icon: "success",
        confirmButtonColor: "green",
        confirmButtonText: "Continue",
      });
    } catch (err: any) {
      if (
        err.response?.data?.message === "jwt expired" ||
        err.response?.data?.message === "jwt malformed"
      ) {
        setReLogin(true);
      } else {
        setReLogin(false);
      }
      Swal.fire({
        title: "Error!",
        text: `${err.response?.data?.message || "An error occurred"}`,
        icon: "error",
        confirmButtonColor: "red",
        confirmButtonText: "Try Again",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-container, .print-container * {
              visibility: visible;
            }
            .print-container {
              position: absolute;
              top: 0;
              left: 0;
              width: 210mm;
            }
            .print-page {
              width: 210mm;
              height: 297mm;
              display: flex;
              flex-direction: column;
              align-items: center;
              page-break-after: always;
            }
            .generatedSlip.cloned-slip {
              width: 203.2mm;
              height: 171.45mm;
              margin-bottom: 2mm;
              position: relative;
            }
            .generatedSlip {
              visibility: hidden !important;
            }
            .waterMark {
              position: absolute;
              top: 120mm;
              left: -15mm;
              transform: rotate(-45deg);
              width: auto;
              text-align: left;
              z-index: 1;
              pointer-events: none;
              color: #000;
            }
            .waterMark span {
              font-size: 45px;
              opacity: 0.3;
              font-weight: bold;
              color: #000;
            }
          }
        `}
      </style>
      <div className="board">
        <ToastContainer />
        {reLogin ? <ReLoginModal /> : null}
        <TopNav title="Merged Loading Slips" />
        {slips.map((details, index) => {
          const businessName =
            details.requisitions[0]?.customer.businessName ||
            "Business Name Unavailable";
          const loadingNumber = details.loadingNumber || "N/A";
          const userRole = details.staff?.role;
          const today = new Date();
          const formattedDate = `${today.getFullYear()}-${String(
            today.getMonth() + 1
          ).padStart(2, "0")}-${String(today.getDate()).padStart(
            2,
            "0"
          )} ${String(today.getHours()).padStart(2, "0")}:${String(
            today.getMinutes()
          ).padStart(2, "0")}`;

          return (
            <form
              key={details._id}
              onSubmit={(e) => handleSubmit(e, details)}
              className="generatedSlip"
            >
              <span
                onClick={() =>
                  setIsEditing((prev) => ({
                    ...prev,
                    [details._id]: !prev[details._id],
                  }))
                }
                className={`editText ${
                  isEditing[details._id] ? "" : "opaque"
                }`}
              >
                <BsPencil /> Edit
              </span>
              <div className="topDetails pb-2">
                <h2 style={{ fontSize: "14px" }}>{businessName}</h2>
                <p style={{ fontSize: "12px" }}>
                  Loading slip No: {loadingNumber}
                </p>
              </div>

              <table>
                <tr className="compa">
                  <td colSpan={2}>Supply Location: {invoices[details._id].supplyLocation}</td>
                  <td colSpan={5}></td>
                  <td colSpan={3} rowSpan={2}>
                    <img className="w-22 h-16" src={logo} alt="" />
                  </td>
                </tr>
                <tr className="compa">
                  <td colSpan={2}>
                    Approval No:{" "}
                    {details.requisitions
                      .map((num: Requisition) => num.approvalNumber)
                      .join(" / ") || "N/A"}
                  </td>
                  <td colSpan={5}>
                    Product: {details.requisitions[0]?.itemName || "N/A"}
                  </td>
                </tr>
                <tr className="compa">
                  <td colSpan={4}>Customer: {businessName}</td>
                  <td colSpan={3}>
                    <span>QTY TO BE LOADED: </span>
                    <strong className="text-sm font-extrabold">
                      {details.requisitions.reduce(
                        (acc: number, req: Requisition) => acc + req.quantityToLoad,
                        0
                      ) || 0}
                    </strong>
                  </td>
                  <td rowSpan={3} colSpan={2}>
                    SPECIFY TANK OR SUB INVENTORY PRODUCT WAS LOADED FROM BELOW
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                </tr>
                <tr className="compa">
                  <td className="destination" colSpan={4}>
                    Destination: <span className="require_star">*</span>
                    <input
                      required
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="destination"
                      value={invoices[details._id].destination}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={3}>
                    QTY LOADED: <span className="require_star">*</span>
                    <input
                      required
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="number"
                      name="quantityLoaded"
                      value={invoices[details._id].quantityLoaded || ""}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                </tr>
                <tr className="compa">
                  <td colSpan={4}>
                    TIME OF BRV ARRIVAL AT IN-GATE
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="time"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={3}>
                    METER BEFORE: <span className="require_star">*</span>
                    <input
                      required
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="number"
                      name="meterBefore"
                      value={invoices[details._id].meterBefore}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                </tr>
                <tr className="compa">
                  <td rowSpan={2} colSpan={1}>
                    SECURITY ALLOW BRV
                  </td>
                  <td colSpan={5}>
                    Driver's Name: <span className="require_star">*</span>
                    <input
                      required
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="driver"
                      value={invoices[details._id].driver}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={3}>
                    METER AFTER:
                    <input
                      type="number"
                      name="meterAfter"
                      value={invoices[details._id].meterAfter}
                      readOnly
                      className="read-only"
                    />
                  </td>
                </tr>
                <tr className="compa">
                  <td colSpan={5}>
                    Loader's Name: <span className="require_star">*</span>
                    <input
                      required
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="loader"
                      value={invoices[details._id].loader}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={3}>
                    TIME LOADING STARTED:
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      name="started"
                      value={
                        invoices[details._id].started || currentDateTime
                      }
                      onChange={(e) => handleChange(details._id, e)}
                      type="datetime-local"
                    />
                  </td>
                </tr>
                <tr className="compa">
                  <td colSpan={1}>
                    Capacity:
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="capacity"
                      value={invoices[details._id].capacity}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={4}>
                    <span>Truck Number: </span><strong className="text-sm font-extrabold">{invoices[details._id].truckNumber}</strong>
                    {isEditing[details._id] && userRole === "admin" && (
                      <input
                        required
                        readOnly={false}
                        className="editable"
                        type="text"
                        name="truckNumber"
                        value={invoices[details._id].truckNumber}
                        onChange={(e) => handleChange(details._id, e)}
                        style={{
                          display:
                            isEditing[details._id] && userRole === "admin"
                              ? "inline"
                              : "none",
                        }}
                      />
                    )}
                  </td>
                  <td colSpan={5}>
                    TIME LOADING ENDED:
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      name="completed"
                      value={
                        invoices[details._id].completed || currentDateTime
                      }
                      onChange={(e) => handleChange(details._id, e)}
                      type="datetime-local"
                    />
                  </td>
                </tr>
                <tr className="compa">
                  <td colSpan={4}>
                    ULLAGER’S NAME <span className="require_star">*</span>
                    <input
                      required
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="ullager"
                      value={invoices[details._id].ullager}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={3}>
                    ULLAGE TIME
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      name="completed"
                      value={
                        invoices[details._id].completed || currentDateTime
                      }
                      onChange={(e) => handleChange(details._id, e)}
                      type="datetime-local"
                    />
                  </td>
                  <td colSpan={3}>
                    C OF Q NO
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="number"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                </tr>
                <tr className="compa volumeSpace">
                  <td>COMPARTMENT NO:</td>
                  <td>1</td>
                  <td>2</td>
                  <td>3</td>
                  <td>4</td>
                  <td>5</td>
                  <td>6</td>
                  <td>7</td>
                  <td>
                    BATCH
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="number"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                </tr>
                <tr className="compa rowSpace">
                  <td colSpan={1}>
                    COMPARTMENT VOL IN LTR: <span className="require_star">*</span>
                  </td>
                  <td rowSpan={1}>
                    <input
                      required
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Cfirst"
                      value={invoices[details._id].Cfirst}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Csecond"
                      value={invoices[details._id].Csecond}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Cthird"
                      value={invoices[details._id].Cthird}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Cfourth"
                      value={invoices[details._id].Cfourth}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Cfifth"
                      value={invoices[details._id].Cfifth}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Csixth"
                      value={invoices[details._id].Csixth}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Cseventh"
                      value={invoices[details._id].Cseventh}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td rowSpan={1} colSpan={1}>
                    S.G
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                </tr>
                <tr className="compa">
                  <td colSpan={1}>
                    ULLAGE <span className="require_star">*</span>
                  </td>
                  <td colSpan={1}>
                    <input
                      required
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Ufirst"
                      value={invoices[details._id].Ufirst}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={1}>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Usecond"
                      value={invoices[details._id].Usecond}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={1}>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Uthird"
                      value={invoices[details._id].Uthird}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={1}>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      name="Ufourth"
                      value={invoices[details._id].Ufourth}
                      type="text"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={1}>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Ufifth"
                      value={invoices[details._id].Ufifth}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={1}>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Usixth"
                      value={invoices[details._id].Usixth}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={1}>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      name="Useventh"
                      value={invoices[details._id].Useventh}
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={3}>
                    ACTUAL TEMP
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                </tr>
                <tr className="compa">
                  <td colSpan={1}>Seal</td>
                  <td colSpan={2}>
                    Seal No
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="number"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={4}>
                    invoice generated time:
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      name="started"
                      value={
                        invoices[details._id].started || currentDateTime
                      }
                      onChange={(e) => handleChange(details._id, e)}
                      type="datetime-local"
                    />
                  </td>
                  <td colSpan={4}>brv out time</td>
                </tr>
                <tr className="compa">
                  <td colSpan={2}>Y/N</td>
                  <td colSpan={2}>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={4}>
                    invoice Signed time:
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      name="completed"
                      value={
                        invoices[details._id].completed || currentDateTime
                      }
                      onChange={(e) => handleChange(details._id, e)}
                      type="datetime-local"
                    />
                  </td>
                  <td colSpan={4}>
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="pb-5" colSpan={2}>
                    gate entry authorisation
                    <input
                      readOnly={!isEditing[details._id]}
                      className={isEditing[details._id] ? "editable" : ""}
                      type="text"
                      onChange={(e) => handleChange(details._id, e)}
                    />
                  </td>
                  <td colSpan={8}>
                    <table>
                      <tr>
                        <th>signature</th>
                        <th>SLIP DATE</th>
                        <th>{formattedDate}</th>
                      </tr>
                      <tr>
                        <td></td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              <p className="w-full text-blue-800">
                generated by {details.staff.name}
              </p>

              {isEditing[details._id] ? (
                <div
                  className="print"
                  style={{
                    justifyContent: "flex-left",
                    flexDirection: "column",
                    alignItems: "flex-left",
                  }}
                >
                  <div className="checks">
                    <input
                      required
                      type="checkbox"
                      checked={invoiceComplete[details._id] || false}
                      onChange={() =>
                        setInvoiceComplete((prev) => ({
                          ...prev,
                          [details._id]: !prev[details._id],
                        }))
                      }
                    />
                    <span>
                      Invoice Complete (Click only when you fill all the input)
                    </span>
                  </div>
                  <button type="submit" className="catBtn11">
                    {loading ? (
                      <CircularProgress
                        style={{
                          color: "#fff",
                          backgroundColor: "transparent",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              ) : null}
            </form>
          );
        })}
        <div className="print mt-8">
          <button
            type="button"
            className="hover:bg-blue-600 bg-blue-500 rounded"
            onClick={() => {
              Object.keys(isEditing).forEach((slipId) =>
                setIsEditing((prev) => ({ ...prev, [slipId]: false }))
              );
              printAllSlips();
            }}
          >
            Print All Slips
          </button>
          <Link to="/dashboard/notinvoiced">close</Link>
        </div>
      </div>
    </>
  );
};

export default MergedGeneratedSlipNotInvoiced;